import { StringHandler } from "src/app/helpers/StringHandler";

export class ContactFormFields {
    name : string;
    email : string;
    message : string;

    constructor(name:string, email:string, message:string) {
        this.name = StringHandler.cleanName(name);
        this.email = email.toLowerCase();
        this.message = message;
    }
}